import React, { useEffect, useState, useCallback } from 'react';
import { get, patch, post } from '../../../services/api-services';
import {
    Box,
    Typography,
    Button,
    LinearProgress,
    Card,
    CardContent,
    IconButton,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate, useParams } from 'react-router-dom';
import EnrollProgramDialog from '../profileModel-DialogBox/AddEnrollProgramDialog';
import AddPaymentDialog from '../profileModel-DialogBox/AddPaymentDialog';
import CancelEnrollment from '../profileModel-DialogBox/CancleEnrollment';
import { useCommon } from '../../../context/CommonContext';
import AddCircleIcon from '@mui/icons-material/AddCircle';
const Programs = ({ userId, refreshTrigger }) => {
    const navigate = useNavigate()
    const [userPrograms, setUserPrograms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isPayment, setIsPayment] = useState(false);
    const { id } = useParams();
    const [allPrograms, setAllPrograms] = useState([]);
    const [tax, setTax] = useState([]);
    const { setSnackbar } = useCommon()
    // Cancel enrollment state
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [cancelProgramId, setCancelProgramId] = useState(null);
    const onGetPrograms = useCallback(async () => {
        const res = await get('/Programs');
        if (res?.statusCode === 200) {
            setAllPrograms(res?.data)
        }
    }, []);

    const onGetTex = useCallback(async () => {
        const res = await get('/Settings?filter={"where" : {"taxType" : "GST"}}');
        if (res?.statusCode === 200) {
            setTax(res?.data[0]?.taxValue);
        }
    }, []);

    const onEnrollProgram = async ({ program, programDate, paymentDueDate, discount, discountNote }) => {
        try {
            const res = await get('/Invoices?filter={"order" : "createdAt DESC", "limit" : "1" }');
            if (res?.statusCode === 200) {
                let invoice_id = 1
                const lastInvoice = res?.data;

                if (lastInvoice?.length > 0) {
                    if (lastInvoice[0].invoiceID && lastInvoice[0].invoiceID !== '') {
                        invoice_id = lastInvoice[0].invoiceID + 1;
                    }
                }
                let status = '';
                if (discount === program?.price) {
                    status = 'Paid';
                } else {
                    status = 'Due';
                }
                let data = { invoiceID: invoice_id, programId: program?.id, purchaseProgram: program, tax: tax, enrollOn: programDate, dueDate: paymentDueDate, feeDiscount: discount, discountNote: discountNote, status: status, createdAt: new Date(), updatedAt: new Date() };
                const postRes = await post('/Invoices', data);
                if (postRes?.statusCode === 200) {
                    let date = new Date();
                    let last = new Date(date.getTime() + (program?.duration * 24 * 60 * 60 * 1000));
                    let userProgramData = {
                        invoiceId: postRes?.data?.id, customerId: id, programId: postRes?.data?.programId,
                        status: 'active', createdAt: new Date(), updatedAt: new Date(), dueAmount: postRes?.data?.purchaseProgram?.price, day: 1, endDate: last
                    };
                    const userProgram = await post('/UserPrograms', userProgramData);
                    if (userProgram?.statusCode === 200) {
                        setSnackbar({
                            openSnackbar: true,
                            message: 'Program enrolled successfully!',
                            severity: 'success'
                        })
                        fetchPayments();
                    }
                }
            }
        } catch (error) {
            console.log("error.....", error)
        }
    }

    const onEditProgram = async ({ program, programDate, paymentDueDate, discount, discountNote, invoiceId, userProgramId, existId }) => {

        try {
            // Ensure the invoiceId comes from the provided data or use a fallback
            let invoice_id = invoiceId;
            let status = discount === program?.price ? 'Paid' : 'Due';

            // Prepare the invoice data
            let invoiceData = {
                enrollOn: programDate,
                dueDate: paymentDueDate,
                feeDiscount: discount,
                discountNote: discountNote,
                // status: status,
                updatedAt: new Date(),
            };

            // Update the invoice
            const invoiceRes = await patch(`/Invoices/${invoice_id}`, invoiceData);
            if (invoiceRes?.statusCode === 200) {

                let userProgramData = {

                    updatedAt: new Date(),
                };

                const userProgramRes = await patch(`/UserPrograms/${existId}`, userProgramData);
                if (userProgramRes?.statusCode === 200) {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Program updated successfully!',
                        severity: 'success',
                    });
                    fetchPayments();
                }
            }
        } catch (error) {
            console.error("Error during program edit...", error);
        }
    };


    const fetchPayments = useCallback(async () => {
        try {
            setLoading(true);

            const userProgramsResponse = await get(
                `/UserPrograms?filter={"where" : {"customerId" : "${id}"}, "include" : "invoice", "order" : "createdAt DESC"}`
            );

            if (!userProgramsResponse?.data) {
                console.error("Failed to fetch user programs");
                setLoading(false);
                return;
            }
            const userProgramsWithPayments = await Promise.all(
                userProgramsResponse.data.map(async (enrollProgram) => {
                    const { programId, invoiceId } = enrollProgram;

                    if (programId && invoiceId) {
                        // Fetch payments for the specific invoice and program
                        const paymentsResponse = await get(
                            `/Payments?filter={"where": {"customerId": "${id}", "programId": "${programId}", "invoiceId": "${invoiceId}"}, "order": "paidOn"}`
                        );

                        const enrollOnDate = new Date(enrollProgram.invoice?.enrollOn);
                        const currentDate = new Date();
                        //Calculate last date of program
                        enrollOnDate.setHours(0, 0, 0, 0);
                        currentDate.setHours(0, 0, 0, 0);
                        const totalDuration = enrollProgram.invoice?.purchaseProgram?.duration || 0;
                        // calculate End Date of program
                        let d = new Date(enrollProgram.invoice?.enrollOn);
                        d.setDate(d.getDate() + parseInt(totalDuration));
                        let completedOn = d;

                        // Calculate elapsed and remaining days
                        const elapsedDays = Math.floor((currentDate - enrollOnDate) / (1000 * 60 * 60 * 24));
                        const remainingDays = Math.max(0, totalDuration - elapsedDays);
                        // Retrieve invoice details and calculate amounts
                        const programPrice = enrollProgram.invoice?.purchaseProgram?.price || 0;
                        const feeDiscount = enrollProgram.invoice?.feeDiscount || 0;
                        const taxRate = enrollProgram.invoice?.tax || 0;

                        const discountedPrice = programPrice - feeDiscount;
                        const sgst = (discountedPrice * taxRate) / 200;
                        const cgst = (discountedPrice * taxRate) / 200;
                        const netAmount = parseFloat((discountedPrice + sgst + cgst).toFixed(2));

                        let runningDueAmount = Math.round(netAmount);

                        // Add remaining amount to each payment
                        const paymentsWithRemaining = (paymentsResponse?.data || []).map((payment) => {
                            const remainingAmount = runningDueAmount - payment.amount;

                            runningDueAmount = remainingAmount;
                            return {
                                ...payment,
                                remainingAmount: remainingAmount < 0 ? 0 : remainingAmount,
                            };
                        });

                        return {
                            ...enrollProgram,
                            paymentData: paymentsWithRemaining,
                            netAmount,
                            remainingDay: remainingDays,
                            completedOn,
                            remainingAmount: runningDueAmount,
                            invoice: {
                                ...enrollProgram.invoice,
                                status: runningDueAmount <= 0 ? 'Paid' : `Due (₹${runningDueAmount})`,
                            },
                        };
                    } else {
                        console.error("Missing programId or invoiceId for enrollProgram:", enrollProgram);
                        return enrollProgram;
                    }
                })
            );

            setUserPrograms(userProgramsWithPayments);
        } catch (error) {
            console.error("Error fetching payment data:", error);
        } finally {
            setLoading(false);
        }
    }, [id]);



    useEffect(() => {
        onGetTex()
        fetchPayments();
        onGetPrograms();
    }, [id, onGetTex, fetchPayments, onGetPrograms, refreshTrigger]);

    const handleViewInvoice = (invoiceId) => {

        navigate(`/admin/invoice/${invoiceId}`)
    }

    const handleDialogOpen = (program = null) => {
        setSelectedProgram(program);
        setIsEditMode(!!program);
        setIsDialogOpen(true);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
        setSelectedProgram(null);
    };

    const handlePaymentDialog = (payment = null) => {
        setSelectedProgram(payment);
        setIsPayment(true);
    }


    const handlePaymentClose = () => {
        setIsPayment(false);
        setSelectedProgram(null);
    };


    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Box >
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 2 }}>
                <Typography variant="body1" >
                    Enrolled Programs
                </Typography>
                {/* <Button variant="text" color="secondary" onClick={() => handleDialogOpen()}>
                    Enroll new programs
                </Button> */}
            </Box>

            {userPrograms.length === 0 && (
                <Typography align="center">Enroll program for the user!</Typography>
            )}

            {userPrograms.map((enrollProgram) => (
                <Card
                    key={enrollProgram.id}
                    sx={{
                        marginBottom: 2,
                        // backgroundColor: enrollProgram.status === 'active' ? '#fff' : '#f5f5f5',
                        boxShadow: 1,
                    }}
                >
                    <CardContent>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6" fontWeight="bold">WeightWonder™  {enrollProgram.invoice?.purchaseProgram?.title} (₹
                                {enrollProgram.invoice?.purchaseProgram?.price})
                            </Typography>
                            <Box display="flex" gap={0.5}>
                                <IconButton
                                    onClick={() => handleDialogOpen(enrollProgram)}
                                    disabled={enrollProgram.status === 'inactive'}
                                >
                                    <EditIcon color="primary" />
                                </IconButton>
                                {enrollProgram.status === 'active' && (
                                    <Tooltip title="Delete Enrollment">
                                        <IconButton
                                            onClick={() => {
                                                setCancelProgramId(enrollProgram.id);
                                                setCancelDialogOpen(true);
                                            }}
                                            sx={{ color: '#ef5350' }}
                                        >
                                            <DeleteOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1.5,
                                fontSize: '0.75rem',
                                marginTop: 1.5,
                            }}
                        >
                            <Typography
                                variant="body2"
                                color='ternary.main'
                                sx={{ fontSize: '0.75rem' }}
                            >
                                {enrollProgram.invoice?.purchaseProgram?.duration} Days
                            </Typography>
                            <Typography
                                variant="body2"
                                color='ternary.main'
                                sx={{ fontSize: '0.75rem' }}
                            >
                                {new Date(enrollProgram.invoice?.enrollOn).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                                <span style={{ margin: '0 5px' }}>To</span>
                                {new Date(enrollProgram?.completedOn).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                            </Typography>

                            <Typography
                                variant="body2"
                                color={enrollProgram.status === 'inactive' ? 'error' : (enrollProgram.remainingDay === 0 ? 'primary' : '#ffc107 ')}
                                sx={{
                                    fontSize: '0.95rem',
                                    marginBottom: 2,
                                }}
                            >
                                {enrollProgram.status === 'inactive' ? 'Cancelled' : (enrollProgram.remainingDay === 0 ? 'Completed' : 'In Progress')}
                            </Typography>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={
                                enrollProgram?.remainingDay === 0
                                    ? 100
                                    : ((enrollProgram?.invoice?.purchaseProgram?.duration - enrollProgram?.remainingDay) /
                                        enrollProgram?.invoice?.purchaseProgram?.duration) *
                                    100
                            }
                            color="secondary"
                            sx={{ height: 5, borderRadius: 4 }}
                        />

                        <Box display="flex" justifyContent="flex-end" sx={{ marginTop: 1 }}>
                            <Typography variant="body2" color='secondary'>
                                {enrollProgram?.remainingDay}d Remaining
                            </Typography>
                        </Box>

                        <Box display="flex" flexWrap="wrap" sx={{ gap: 2, marginTop: 2 }}>
                            <Typography variant="body2">
                                Discount: <span style={{ color: '#90caf9' }}> ₹{enrollProgram?.invoice?.feeDiscount || '0'}</span>
                                <Tooltip title={enrollProgram?.invoice?.discountNote || ''} arrow>
                                    <InfoIcon color="primary" disabled sx={{ marginLeft: 1 }} />
                                </Tooltip>
                            </Typography>

                            <Typography variant="body2">
                                Net Fee: <span style={{ color: '#4caf50' }}>₹{enrollProgram?.netAmount}</span>
                            </Typography>


                            <Typography variant="body2">
                                Fee Status:&nbsp;
                                {enrollProgram?.invoice?.status === 'Paid' ? (
                                    <>
                                        <span style={{ color: '#4caf50' }}>✔ Paid</span>
                                    </>
                                ) : (
                                    <>
                                        <span style={{ color: 'red' }}>(₹{enrollProgram?.remainingAmount}) Due</span>
                                    </>
                                )}
                            </Typography>

                            {enrollProgram?.invoice?.status !== 'Paid' && enrollProgram.status === 'active' && (
                                <AddCircleIcon
                                    variant="text"
                                    onClick={() => handlePaymentDialog(enrollProgram)}
                                    sx={{
                                        padding: 0,
                                        color: (theme) => theme.palette.mode === 'dark' ? '#fff' : 'black',
                                    }}
                                >

                                </AddCircleIcon>
                            )}

                            <Button
                                variant="text"
                                onClick={() => handleViewInvoice(enrollProgram?.invoiceId)}
                                sx={{ padding: 0 }}
                                disabled={enrollProgram.status === 'inactive'}
                            >
                                VIEW INVOICE
                            </Button>
                        </Box>

                        {enrollProgram?.paymentData && enrollProgram?.paymentData?.length > 0 && (
                            <Box mt={4}>
                                <TableContainer component={Paper} className="border border-gray-300">
                                    <Table>
                                        <TableHead>
                                            <TableRow color="ternary.main" className="border-b border-gray-200">
                                                <TableCell>Paid On</TableCell>
                                                <TableCell>Paid Amount</TableCell>
                                                <TableCell>Remaining Amount</TableCell>
                                                <TableCell>Payment Mode</TableCell>
                                                <TableCell>Comments</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {enrollProgram?.paymentData
                                                .reverse() // Reverse the array to show the latest payments first
                                                .map((payment) => (
                                                    <TableRow key={payment.id}>
                                                        <TableCell>
                                                            {new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(payment.paidOn))}
                                                        </TableCell>

                                                        <TableCell>₹{payment.amount}</TableCell>
                                                        <TableCell>₹{payment.remainingAmount}</TableCell>
                                                        <TableCell>{payment.paymentMode}</TableCell>
                                                        <TableCell>{payment.comment || '-'}</TableCell>
                                                        <TableCell>
                                                            <IconButton onClick={() => handlePaymentDialog(payment)}>
                                                                <EditIcon color="primary" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        )}

                    </CardContent>
                </Card>
            ))}
            <EnrollProgramDialog
                open={isDialogOpen}
                onClose={handleDialogClose}
                allPrograms={allPrograms}
                onSubmit={isEditMode ? onEditProgram : onEnrollProgram}
                mainId={isEditMode ? selectedProgram?.id : null}
                programId={isEditMode ? selectedProgram?.programId : null}
                existingProgramData={selectedProgram}
                onCancelSuccess={() => {
                    handleDialogClose();
                    fetchPayments();
                }}
            />
            <AddPaymentDialog
                open={isPayment}
                onClose={handlePaymentClose}
                existingProgramData={selectedProgram || null}
                fetchPayments={fetchPayments}
            // paymentId={selectedProgram}
            />
            <CancelEnrollment
                open={cancelDialogOpen}
                onClose={() => {
                    setCancelDialogOpen(false);
                    setCancelProgramId(null);
                    // Refresh the list after cancellation
                    fetchPayments();
                }}
                mainId={cancelProgramId}
            />
        </Box>
    );
};
export default Programs;